import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'sh-b2b-footer',
  templateUrl: './b2b-footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./b2b-footer.component.scss'],
})
export class B2bFooterComponent implements OnInit {
  currentYear: number;

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();
  }
}
